import {
    ComponentServices,
    CurationData,
    DataLoaderGlobalParams,
    getCuration,
    mapListPublication,
    PublicationCardItem,
} from '@news-mono/web-common'
import { DataDefinition } from 'json-react-layouts-data-loader'

// SWM-4936 This custom data loader is necessary until the general purpose curation loader includes metadata

export interface BreakingNewsDataResult {
    metadata: { [key: string]: any }
    articles: PublicationCardItem[]
}
export type BreakingNewsDataDefinition = DataDefinition<
    CurationData,
    BreakingNewsDataResult,
    ComponentServices
>

export const BreakingNewsDataDefinitionLoader: BreakingNewsDataDefinition = {
    loadData: (props, services) => loadBreakingNewsData(services, props),
}

async function loadBreakingNewsData(
    services: DataLoaderGlobalParams,
    data: CurationData,
): Promise<BreakingNewsDataResult> {
    const curation = await getCuration(services, data.name, {})

    const mappedCollectionItems = curation.articles.map((listPublication) =>
        mapListPublication(listPublication),
    )

    return {
        metadata: curation.metadata,
        articles: mappedCollectionItems,
    }
}
